var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.3405 1.99982H7.67049C4.28049 1.99982 2.00049 4.37982 2.00049 7.91982V16.0898C2.00049 19.6198 4.28049 21.9998 7.67049 21.9998H16.3405C19.7305 21.9998 22.0005 19.6198 22.0005 16.0898V7.91982C22.0005 4.37982 19.7305 1.99982 16.3405 1.99982Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8134 15.2479C10.5894 15.2479 10.3654 15.1629 10.1944 14.9919L7.82144 12.6189C7.47944 12.2769 7.47944 11.7229 7.82144 11.3819C8.16344 11.0399 8.71644 11.0389 9.05844 11.3809L10.8134 13.1359L14.9414 9.0079C15.2834 8.6659 15.8364 8.6659 16.1784 9.0079C16.5204 9.3499 16.5204 9.9039 16.1784 10.2459L11.4324 14.9919C11.2614 15.1629 11.0374 15.2479 10.8134 15.2479Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.1d078870cf7fa9d118fd03d800fc9267.svg";
export { ForwardRef as ReactComponent };